
<template>
  <div id="menuTopBar" class="layout-topbar">
    <button id="toggle-sidebar" class="p-link layout-menu-button" @click="onMenuToggle">
      <span style="font-size: 24px;" :class="'pi ' + (!menuClick ? 'pi-arrow-right' : 'pi-arrow-left' )"></span>
    </button>
    <div id="topbarIcon" class="layout-topbar-icons">
      <button id="btnProfile" class="p-link" @click="OnShow">
        <span class="layout-topbar-item-text">User</span>
        <span class="layout-topbar-icon pi pi-user"></span>
      </button>
      <OverlayPanel ref="op" appendTo="btnProfile" id="overlay_panel">
        <div>
          <a title="Thông tin cá nhân" @click='openChangeProfile()'>
            <span class="pi pi-user "></span>Thông tin cá nhân
          </a>
        </div>
        <div>
          <a @click='submitLogout' title="Đăng xuất">
            <span class="pi pi-sign-out"></span> Đăng xuất 
          </a>
        </div>
      </OverlayPanel>
    </div>
    <Dialog header="ĐĂNG XUẤT" :visible.sync="displayLogout" :style="{width: '350px','text-align': 'center'}" :modal="true" :position="position">
      <div class="confirmation-content">
          <span>Bạn có chắc muốn đăng xuất khỏi tài khoản này không?</span>
      </div>
      <template #footer>
        <div class="custom-center">
          <Button label="Xác nhận" @click="validateLogout()" class="p-button-text default-custom-btn" autofocus="autofocus" />
          <Button label="Hủy" @click="closeLogout()" class="p-button-text p-button-danger default-custom-btn" />
        </div>
      </template>
    </Dialog>

    <Dialog header="Thông tin cá nhân" :visible.sync="displayChangeProfile" :style="{width: '400px'}" :modal="true" :position="position">
      <div class="confirmation-content">
        <span class="" style="color:red" v-if='error'> {{error}}</span>
        <form action="#" autocomplete="off">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group custom-form-group" style="position: relative">
                <label class="control-label">Họ và tên <span class="error">*</span></label>
                <InputText id="fullname" type="text" v-model="fullname" class="form-control form-custom-pass custom-pass-input" :placeholder="'Nhập họ và tên'"/>
                <i class="material-icons lg-icon-password"><span class="pi pi-user"></span></i>
                <small v-if="validationErrors && validationErrors['fullname']" class="p-invalid" >{{validationErrors['fullname']}}</small>
              </div>
              <div class="form-group custom-form-group" style="position: relative">
                <label class="control-label">Số điện thoại <span class="error">*</span></label>
                <InputText :disabled="true" id="phone_number" type="text" v-model="phone_number" class="form-control form-custom-pass custom-pass-input" :placeholder="'Nhập số điện thoại'"/>
                <i class="material-icons lg-icon-password"><span class="pi pi-phone"></span></i>
                <small v-if="validationErrors && validationErrors['phone_number']" class="p-invalid" >{{validationErrors['phone_number']}}</small>
              </div>
              <div class="form-group custom-form-group" style="position: relative">
                <label class="control-label">Email</label>
                <InputText id="email" type="text" v-model="email" class="form-control form-custom-pass custom-pass-input" :placeholder="'Nhập email'"/>
                <i class="material-icons lg-icon-password"><span class="pi pi-envelope"></span></i>
                <small v-if="validationErrors && validationErrors['email']" class="p-invalid" >{{validationErrors['email']}}</small>
              </div>
              <div class="form-group custom-form-group" style="position: relative; margin:0;">
                <label class="control-label">Đơn vị công tác</label>
                <div class="form-control p-dropdown p-component custom-padding">
                  <span class="p-inputtext p-dropdown-label">{{ organization_name }}</span>
                  <div class="p-dropdown-trigger" role="button">
                    <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template #footer>
        <div class="custom-center">
          <Button label="Lưu" @click="saveData()" class="p-button-text default-custom-btn" autofocus />
          <Button label="Hủy" @click="closeChangeProfile()" class="p-button-text p-button-danger default-custom-btn" />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
export default {
  props: {
    menuClick: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      user_id: 0,
      fullname: '',
      phone_number: '',
      email: '',
      show: false,
      displayLogout: false,
      displayChangeProfile: false,
      error: null,
      position : 'top',
      organization_name: '',
      organizations: [],
      validationErrors: {}
    }
  },
  methods: {
    onMenuToggle(event) {
      this.$emit('menu-toggle', event);
    },
    OnShow(event) {
      this.$refs.op.toggle(event);
    },
    submitLogout() {
      this.displayLogout = true;
    },
    closeLogout() {
      this.displayLogout = false;
    },
    closeChangeProfile() {
      this.displayChangeProfile = false;
    },
   
    async openChangeProfile() {
      this.error = null;
      if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null) {
        let phone_number = this.$store.getters.fullname.phone_number;
        if(phone_number != undefined && phone_number != null) {
          this.phone_number = phone_number;
          var variables = {
            where_key: {
              phone_number: {'_eq': phone_number},
              status: {'_eq': 1}
            }
          }
          var dtData = await DataServices.getList('users', {"variables": JSON.stringify(variables), 'fields' : 'id, full_name, email, organization_account { organization { name } }'});
          if (dtData != undefined && dtData != null) {
            var users = dtData[Object.keys(dtData)];
            if (users != undefined && users != null && Object.keys(users).length > 0) {
              this.user_id = (users[0].id != undefined && users[0].id != null) ? users[0].id : 0;
              this.fullname = (users[0].full_name != undefined && users[0].full_name != null) ? users[0].full_name : '';
              this.email = (users[0].email != undefined && users[0].email != null) ? users[0].email : '';
              this.organization_name = (users[0].organization_account != undefined && users[0].organization_account != null && users[0].organization_account.organization != undefined && users[0].organization_account.organization != null) ? users[0].organization_account.organization.name : '';
            }
          }
        }
        this.displayChangeProfile = true;
      }
    },
    validateLogout() {
      localStorage.removeItem("phone_number");
      localStorage.removeItem("isLoggedIn");
      this.$store.commit('setToken', '');
      this.$store.commit('setFullname', null);
      this.$router.push('/login');
    },
    async validateData() {
        this.validationErrors = {};
        if (this.fullname === undefined || this.fullname == '') this.validationErrors['fullname'] = 'Nhập họ và tên';
        if (this.phone_number === undefined || this.phone_number == '') this.validationErrors['phone_number'] = 'Nhập số điện thoại';
        if (this.email === undefined || this.email == '') this.validationErrors['email'] = 'Nhập email';
    },
    async saveData() {
      await this.validateData();
      if (Object.entries(this.validationErrors).length === 0 && this.user_id > 0) {
        var params = {
          'full_name': (!this.$myConstants.isEmpty(this.fullname)) ? this.$myConstants.capitalizeFirst(this.fullname):'',
          'email': this.email,
          'modified_date': this.$myConstants.currentDate()
        }
        await DataServices.updateData('users', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.user_id }}})});
        this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
        this.displayChangeProfile = false;
      }
    }
  },
}
</script>
<style lang="scss">
#overlay_panel {top: 15px !important; left: unset !important;  right: 0 !important;width: 200px;
  .p-overlaypanel-content {
    div{margin-bottom: 10px;
      a {
        span{padding-right: 10px;}
      }
      &:last-child{margin: 0;}
    }
  }
}
.custom-padding { padding: 0 10px; opacity: 0.5;
  .p-dropdown-trigger{ width: auto;}
}

.form-custom-pass{
  padding-right: 40px !important;
  padding-right: 42.5px;
  border-radius: 3px !important;
  box-shadow: none;
  border-color: #d2d6de;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  font-family: inherit;
}
.lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
}
.custom-pass-input{
  margin-top: 2px;
}
.default-custom-btn{
  width: 125px !important;
}
.custom-center{
  text-align: center;
}
.layout-menu-button {outline-offset: inherit; height: 39px; position: relative; margin-top: -4px; box-shadow: inherit !important;
  span {outline: none;display: block; padding: 0 10px;}
}
</style>